import * as api from "../../../api"; 
import { appTokenString } from "../../../constants/appInfo";

  
export const getAllProductsByAppForClients = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.getAllProductsByAppForClients(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}

export const handleEnrollmentActionsByClientsAPI = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.handleEnrollmentActionsByClientsAPI(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}

export const handleEnrollmentsFilterByUser = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.handleEnrollmentsFilterByUser(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}


export const getSubCoursesClientByCourseId = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.getSubCoursesClientByCourseId(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}




export const getMilestonesClientsBySubCourse = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.getMilestonesClientsBySubCourse(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}



export const getSectionsClientByMilestone = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.getSectionsClientByMilestone(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}




export const getContentsClientBySection = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.getContentsClientBySection(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}




export const getContentsClientByFolder = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.getContentsClientByFolder(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}




export const getContentsClientByChapter = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.getContentsClientByChapter(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}






